<template>
  <span>
    <b-button
      variant="secondary"
      v-b-tooltip.hover.bottom.v-secondary
      :title="'Click to provide alternate ' + dataTypeName"
      @click="$bvModal.show('alternatePartInfoModal-' + id_key)"
      size="sm"
    >
      <i class="fa fa-edit"></i>
    </b-button>

    <b-modal
      :id="'alternatePartInfoModal-' + id_key"
      centered
      ref="modal"
      title="Alternate Part Information"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >

      <b-container fluid >
        <div class="partInputDiv">
          <b-input-group>
            <template v-slot:prepend>
              <b-input-group-text>Alternate {{dataTypeName}}</b-input-group-text>
            </template>
            <b-form-input
              v-model="internalPartInfo.name"
              :state="namePropertyState"
              autofocus
              :type="nameTypeInput"
              @input="nameChanged"
            ></b-form-input>
            <b-form-invalid-feedback id="internalPartInfo_name-feedback">
              {{ nameErrorMessage }}
            </b-form-invalid-feedback>
          </b-input-group>
        </div>

        <b-form-group label="Does this have the same form, fit and function?">
          <b-form-radio-group
            id="radio-group-2"
            v-model="internalPartInfo.is_form_fit_function_match"
            name="radio-sub-component"
            :options="formFitFunctionOptions"
            :state="formFitFunctionState"
          >
            <span
              class="formFitFunctionInvalid"
              v-if="internalPartInfo.is_form_fit_function_match === false"
            >Cannot proceed if this value is 'No.'</span>
          </b-form-radio-group>
        </b-form-group>

        <div  v-if="dataType === 'NSN'">
          Please explain below why you want to use this alternate NSN.
        </div>

        <div  v-else>
          Please explain below why you want to use this alternate Part Number.
          Is it a superseding part number, or an alternate product? Was this part Number
          previously approved?
        </div>

        <div>
          <b-form-group id="description" label label-for="input-description"
            >
            <b-form-textarea
              id="input-description"
              v-model="internalPartInfo.description"
              rows="6"
              wrap="hard"
              :state="descriptionState"
              @input="descriptionChanged"
            ></b-form-textarea>
            <b-form-invalid-feedback >
              {{ descriptionErrorMessage }}
            </b-form-invalid-feedback>

          </b-form-group>
        </div>
      </b-container>

    </b-modal>
    <!-- end of modal -->
  </span>
</template>


<script>
import { eventBus } from '../../main.js'

export default {
  name: "alternatepart_modal",
  props: [
    "id",
    "externalPartInfo",
    "dataType", // expects either the string "NSN" or "PartNumber"
    "id_key",
  ],
  components: {

},

  computed: {
    namePropertyState() {
      if(this.internalPartInfo.name == null || this.internalPartInfo.name.length === 0) { return false; }

      if(this.dataType === 'NSN' && this.internalPartInfo.name.length != 13) 
      { 
        return false;
      }
      else
      { 
        return (this.internalPartInfo.name.length > 2); 
      }
    },

    formFitFunctionState() {
      return (this.internalPartInfo.is_form_fit_function_match);
      // if(this.internalPartInfo.is_form_fit_function_match == null || this.internalPartInfo.is_form_fit_function_match == true)
      // { return null; }
      // else
      // { return false; }
    },

    descriptionState() {
      return (this.internalPartInfo.description == null ? false :
        this.internalPartInfo.description.trim().length >= 10
      );
    }
  },
  data() {
    return {
      lineDisposition: 0,
      willAdviseMinDate: new Date(),
      lineDetailsCollapsed: true,
      partDetailOptions: [],
      internalPartInfo: {
        name: null,
        is_form_fit_function_match: null,
        description: null,
      },
      dataTypeName: "",
      nameErrorMessage: "",
      descriptionErrorMessage: "",
      nameTypeInput: "number",

      formFitFunctionOptions: [
        { text: "Yes", value: true  },
        { text: "No",  value: false },
      ],
    };
  },

  methods: {
    nameChanged() {
      if(this.internalPartInfo.name == null || this.internalPartInfo.name.length === 0) { 
        this.nameErrorMessage = ""; 
      }

      if(this.dataType === 'NSN' && this.internalPartInfo.name.length != 13) 
      { 
        //console.log("got to nameChanged -- NSN");
        this.nameErrorMessage = "NSN must be exactly 13 digits";
      }
      else
      { 
        //console.log("got to nameChanged -- PartNumber");
        this.nameErrorMessage = "Part Number must be more than 2 characters";
      }
    },
    
    descriptionChanged() {
      //console.log("got into descriptionChanged");
      this.descriptionErrorMessage = "";

      if(this.internalPartInfo.description.trim().length < 10)
      { this.descriptionErrorMessage = "Explanation is required." }

      //console.log("this.descriptionErrorMessage = " + this.descriptionErrorMessage);
    },

    resetModal() {
      //console.log("resetModal firing");
      this.internalPartInfo = {
        name: null,
        is_form_fit_function_match: null,
        description: null,
      }; // blank out the internal copy
    },
    handleOk(bvModalEvt) {
      //console.log("handleOk()");

      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    handleSubmit() {
      // Exit when the data is not valid
      //console.log("this.namePropertyState = " + this.namePropertyState);
      //console.log("this.formFitFunctionState = " + this.formFitFunctionState);
      //console.log("this.descriptionState = " + this.descriptionState);
      var noErrors = (this.namePropertyState && this.descriptionState && (this.formFitFunctionState == true) ); // formFitFunctionState might be null
      console.log("noErrors = " + noErrors);

      if (!noErrors) {
        var errorMsg = 'Correct errors in the input.';         
        this.$bvModal.msgBoxOk(errorMsg, {
          title: 'Warning',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          centered: true
        });

        return;
      }

      // send results back
      this.externalPartInfo.name = this.internalPartInfo.name.trim();
      this.externalPartInfo.is_form_fit_function_match = this.internalPartInfo.is_form_fit_function_match;
      this.externalPartInfo.description = this.internalPartInfo.description.trim();

      // Hide the modal 
      this.$nextTick(() => {
        this.$bvModal.hide("alternatePartInfoModal-" + this.id_key);
        eventBus.$emit('alternatePartInfo_Changed', [this.dataType, this.externalPartInfo]);  // send the new data out 
        console.log("emitted events");
      });
    }
  },

  mounted: function () {
    
    //console.log(this.dataType);
    //console.log(JSON.stringify(this.externalPartInfo));
    this.internalPartInfo = JSON.parse(JSON.stringify(this.externalPartInfo));
    this.dataTypeName = this.dataType === "NSN" ? "NSN" : "Part Number";
    if(this.dataType === "NSN")
    {
      this.nameTypeInput = "number";  // makes the name input accept only digits for NSNs
      this.nameErrorMessage = "NSN must be exactly 13 digits";
    } else { 
      this.nameTypeInput = "text"; // accepts all characters for PartNumbers
      this.nameErrorMessage = "Part Number must be more than 3 characters";
    }
  },
};
</script>

<style scoped>
.btn-sm {
  border-radius: 0rem;
}

.partInputDiv {
  margin-bottom: 27px;
}

.melJackiePatti {
  font-size: 80%;
  background-color: cornsilk;
  font-style: italic;
}

.formFitFunctionInvalid {
  color:#dc3545;
  font-size: 80%;
  margin-left: 12px;
}
</style>